import {createFileRoute} from '@tanstack/react-router'
import React from 'react'
import {config} from '@/config/config.ts'
import LandingNav from '@/landing/components/LandingNav.tsx'
import FooterSection from '@/landing/sections/FooterSection.tsx'
import StreamHelpContent from '@/overlay/StreamHelpContent.tsx'

// Public help page for the streaming overlay; the Stream Live page shows the same content in a pop-up.
export const Route = createFileRoute('/help/streaming-overlay')({
    component: StreamingOverlayHelp,
    head: () => ({
        meta: [
            {title: 'Add the ScorePal score overlay to your stream | ScorePal'},
            {name: 'description', content: 'Put a live score bug on your OBS, Streamlabs or phone stream with one link per court.'},
        ],
        links: [{rel: 'canonical', href: `${config.publicUrl}/help/streaming-overlay/`}],
    }),
})

function StreamingOverlayHelp() {
    return (
        <div className="min-h-screen bg-white text-[#0b1e3f]">
            <LandingNav />
            <main className="mx-auto max-w-3xl px-5 py-12">
                <p className="text-xs font-semibold uppercase tracking-widest text-primary">Help</p>
                <h1 className="mb-3 mt-2 text-3xl font-bold">Add the score overlay to your stream</h1>
                <StreamHelpContent />
            </main>
            <FooterSection />
        </div>
    )
}
